import { Routes } from '@angular/router';

import { AuthService } from './auth.service';
import { LoginAuthComponent } from './login';
import { LogoutAuthComponent } from './logout.auth.component';
import { ResetPasswordAuthComponent } from './reset-password.auth.component';

export const AuthRoutes: Routes = [
    {
        path: 'login',
        component: LoginAuthComponent,
        canActivate: [AuthService],
    },
    {
        path: 'logout',
        component: LogoutAuthComponent,
    },
    {
        path: 'reset-password',
        component: ResetPasswordAuthComponent,
    },
];
